<h3>Idées</h3>
@for (slot of [
    {ideas: conventionalImpossible(), name: 'conventionalImpossible'},
    {ideas: conventionalPossible(), name: 'conventionalPossible'},
    {ideas: originalImpossible(), name: 'originalImpossible'},
    {ideas: originalPossible(), name: 'originalPossible'}
]; track slot.name) {
    <h4>{{slot.ideas.length}} {{ slot.name }}</h4>
    <ul>
        @for (idea of slot.ideas; track idea.idea) {
            <li>{{ idea.idea }}</li>
        }
    </ul>
}